export default __webpack_public_path__ + "static/media/logo-coinbase.87e91c7f.svg";